import React from "react";
import { Link } from "react-router-dom";
import { Flower2 } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="mt-32 border-t"
      style={{ borderColor: "#EAE5D9", backgroundColor: "#F3EFE9" }}
      data-testid="main-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Flower2 size={24} color="#D96C4A" />
            <span className="font-serif-display text-xl text-[#2D3B31]">Gītā Sabhā</span>
          </div>
          <p className="text-sm text-[#5C6B5F] leading-relaxed max-w-xs">
            A peaceful gathering for learners, seekers, and students of the Bhagavad Gītā.
            Study, reflect, and converse with reverence.
          </p>
        </div>
        <div>
          <div className="text-xs tracking-widest uppercase text-[#8A948C] mb-3">Explore</div>
          <ul className="space-y-2 text-sm text-[#2D3B31]">
            <li><Link to="/chapters" className="hover:text-[#D96C4A]">All 18 Chapters</Link></li>
            <li><Link to="/register" className="hover:text-[#D96C4A]">Join the Community</Link></li>
            <li><Link to="/login" className="hover:text-[#D96C4A]">Sign in</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs tracking-widest uppercase text-[#8A948C] mb-3">Community Code</div>
          <p className="text-sm text-[#5C6B5F] leading-relaxed">
            Speak with kindness. Disagree with curiosity. Every voice here is a seeker.
            Moderators ensure our sabhā remains harmonious.
          </p>
        </div>
      </div>
      <div className="text-center pb-8 text-xs text-[#8A948C] font-serif-display italic">
        “Yoga is skill in action” — Bhagavad Gītā 2.50
      </div>
    </footer>
  );
}
